export default {
  reservas: [],
  minhasReservas: [],
  areasDisponiveis: [],
  reservaEmAndamento: {},
  termoReservaEmAndamento: '',
  convidados: [],
}
